// extracted by mini-css-extract-plugin
module.exports = {"load":"Spinner_load__hW0gq","loader":"Spinner_loader__-8_dn","load8":"Spinner_load8__72vOH"};